import React, { useEffect, useState } from 'react'
import { createFirstFifty, verifyRecaptcha } from '../../apis/apiList/firstFiftyApi';
import { useMessage } from '../../context/MessageContext';
import { useNavigate } from 'react-router-dom';

function ReserveSpot() {
    useEffect(() => {
        const inputs = document.querySelectorAll(".contact-form .entry input");

        const handleFocus = (e) => {
        e.target.closest(".entry")?.classList.add("input_focus");
        };

        const handleBlur = (e) => {
        e.target.closest(".entry")?.classList.remove("input_focus");
        };

        const handleInput = (e) => {
        const entry = e.target.closest(".entry");
        if (e.target.value !== "") {
            entry?.classList.add("value_focus");
        } else {
            entry?.classList.remove("value_focus");
        }
        };

        inputs.forEach((input) => {
        input.addEventListener("focus", handleFocus);
        input.addEventListener("blur", handleBlur);
        input.addEventListener("input", handleInput);
        });

        // Cleanup event listeners when component unmounts
        return () => {
        inputs.forEach((input) => {
            input.removeEventListener("focus", handleFocus);
            input.removeEventListener("blur", handleBlur);
            input.removeEventListener("input", handleInput);
        });
        };
    }, []);

    const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    organization: "",
  });

  const { showMessage } = useMessage();

  const [errors, setErrors] = useState({});
  const navigate = useNavigate();

  const validate = () => {
    const newErrors = {};

    if (!formData.name.trim()) {
      newErrors.name = "Name is required.";
    }

    if (!formData.email.trim()) {
      newErrors.email = "Email is required.";
    } else if (!/^\S+@\S+\.\S+$/.test(formData.email)) {
      newErrors.email = "Invalid email format.";
    }

    if (!formData.phone.trim()) {
      newErrors.phone = "Phone is required.";
    } else if (!/^\d{10}$/.test(formData.phone)) {
      newErrors.phone = "Phone must be 10 digits.";
    }

    if (!formData.organization.trim()) {
      newErrors.organization = "Organization is required.";
    }

    return newErrors;
  };

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = async(e) => {
    e.preventDefault();
    const validationErrors = validate();
    // setErrors(validationErrors);
    const token = window.grecaptcha.getResponse();

    if (!token) {
        setErrors({ ...validationErrors, recaptcha: "Please complete the reCAPTCHA" }); // ✅ this is correct...
        return;
    }

    if (Object.keys(validationErrors).length === 0) {
        try {

            // Step 2: Verify CAPTCHA token with your backend
            const verifyResult = await verifyRecaptcha({
                "g-recaptcha-response": token
            })

            console.log('verifyResult', verifyResult);
            if (!verifyResult.success) {
                // showMessage("reCAPTCHA verification failed", "error");
                setErrors({...errors, recaptcha: "reCAPTCHA verification failed"});
                return;
            }

            const response = await createFirstFifty(formData);
    
            showMessage(response.message, 'success')
            navigate('/first-50/onboarding')
            setFormData({
                name: "",
                email: "",
                phone: "",
                organization: "",
            })
            window.grecaptcha.reset();
            setErrors({});
            const entries = document.querySelectorAll(".contact-form .entry");
            entries.forEach((entry) => {
                entry.classList.remove("input_focus");
                entry.classList.remove("value_focus");
            });
        } catch (error) {
            console.error('Error submitting form:', error);
            showMessage(error?.response?.data?.message, 'error')
        }
    }
  };
  return (
    <section className="reserve-your-spot" id="reserve-your-spot">
        <div className="row ">
            <div className="container">
                <div className="reserve-content-wrap">
                    <div className="reserve-content wow fadeInLeft">
                        <div className="title">
                            <h2>Reserve Your Spot in the <span className="red">First 50 Club</span></h2>
                            {/* <!-- <h2>Reserve Your Spot <span className="red">in the First 50 Club </span></h2> --> */}
                        </div>
                        <p>Ready to see how Snapshot Videos can work for your association? Fill out the form
                            below and we’ll set up a time to talk. No pressure, just a quick chat to explore how
                            it might fit your needs.</p>
                    </div>
                    <div className="contact-form wow zoomIn">
                        <form className="from-ct" id="contact-enquiryform" onSubmit={handleSubmit}>
                            <div className="ct-form-field-warps">
                                <div className="fields-wrap sf-name-wrap">
                                    <div className="entry input-wrap">
                                    <label htmlFor="name">Name<span>*</span></label>
                                    <input
                                        type="text"
                                        id="name"
                                        name="name"
                                        className="form-control form-booking"
                                        value={formData.name}
                                        onChange={handleChange}
                                    />
                                    {errors.name && <small style={{ color: "red" }}>{errors.name}</small>}
                                    </div>
                                </div>

                                <div className="fields-wrap sf-email-wrap">
                                    <div className="entry input-wrap">
                                    <label htmlFor="email">Email<span>*</span></label>
                                    <input
                                        type="text"
                                        id="email"
                                        name="email"
                                        className="form-control form-booking"
                                        value={formData.email}
                                        onChange={handleChange}
                                    />
                                    {errors.email && <small style={{ color: "red" }}>{errors.email}</small>}
                                    </div>
                                </div>

                                <div className="fields-wrap sf-message-wrap">
                                    <div className="entry input-wrap">
                                    <label htmlFor="phone">Phone<span>*</span></label>
                                    <input
                                        type="text"
                                        id="phone"
                                        name="phone"
                                        className="form-control form-booking"
                                        value={formData.phone}
                                        onChange={handleChange}
                                    />
                                    {errors.phone && <small style={{ color: "red" }}>{errors.phone}</small>}
                                    </div>
                                </div>

                                <div className="fields-wrap sf-number-wrap">
                                    <div className="entry input-wrap">
                                    <label htmlFor="Organization">Organization<span>*</span></label>
                                    <input
                                        type="text"
                                        id="Organization"
                                        name="organization"
                                        className="form-control form-booking"
                                        value={formData.organization}
                                        onChange={handleChange}
                                    />
                                    {errors.organization && <small style={{ color: "red" }}>{errors.organization}</small>}
                                    </div>
                                </div>

                                <div class="form-field recaptcha captcha-wrap" id="recaptcha2">
                                    <div class="recaptcha-div">
                                        <div class="g-recaptcha"
                                            data-sitekey={process.env.REACT_APP_GOOGLE_RECAPTCHA_SITE_KEY}></div>
                                    </div>
                                </div>
                                {errors.recaptcha && <p style={{ color: "red", textAlign: 'center', fontSize: '14px' }}>{errors.recaptcha}</p>}
                                <script src="https://www.google.com/recaptcha/api.js" async defer></script>
                            </div>

                            <div className="google-submit enquiry-button-wrapper btn order-btn">
                            <input
                                type="submit"
                                value="Submit Now"
                                className="csubmit-btn1 f-submit"
                                name="btnsubmit1"
                            />
                            <div style={{ display: "none" }} id="ajaxLoader" className="ajaxLoader">
                                <img alt="loading" src="./images/loader.gif" />
                            </div>
                            </div>
                        </form>
                        </div>
                </div>
            </div>
        </div>
    </section>
  )
}

export default ReserveSpot